type Stats = {
  editaisAtivos: number;
  totalProponentes: number;
  cadastrosPendentes: number;
  projetosAvaliacao: number;
};

export default function StatsGrid({ stats }: { stats: Stats }) {
  return (
    <div className="grid grid-cols-4 gap-6 mb-6">
      <div className="bg-white p-5 border border-gray-200">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-gray-600">Editais Ativos</span>
        </div>
        <div className="text-3xl font-semibold text-gray-900">
          {stats.editaisAtivos}
        </div>
        <div className="text-xs text-gray-500 mt-1">Total em andamento</div>
      </div>

      <div className="bg-white p-5 border border-gray-200">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-gray-600">Proponentes</span>
        </div>
        <div className="text-3xl font-semibold text-gray-900">
          {stats.totalProponentes}
        </div>
        <div className="text-xs text-gray-500 mt-1">Cadastros ativos</div>
      </div>

      <div className="bg-white p-5 border border-gray-200">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-gray-600">Pendentes</span>
        </div>
        <div className="text-3xl font-semibold text-gray-900">
          {stats.cadastrosPendentes}
        </div>
        <div className="text-xs text-gray-500 mt-1">Aguardando análise</div>
      </div>

      <div className="bg-white p-5 border border-gray-200">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-gray-600">Em Avaliação</span>
        </div>
        <div className="text-3xl font-semibold text-gray-900">
          {stats.projetosAvaliacao}
        </div>
        <div className="text-xs text-gray-500 mt-1">Projetos submetidos</div>
      </div>
    </div>
  );
}
